import React, { useRef } from 'react';
import { IAction } from '../../../../types/Action/IAction';
import { Button, ButtonGroup, ButtonHandle, DropDownButton, DropDownButtonItem, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import LikeButton from './LikeButton';
import * as svg from '@progress/kendo-svg-icons';
import AttachmentButton from './AttachmentButton';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { Link, useNavigate } from 'react-router-dom';
import { MenuItemModel } from '@progress/kendo-react-layout';
import { Align } from '@progress/kendo-react-popup';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { SetSelectedActions } from '../../../../slices/SelectedActionsSlice';
import StopwatchImage from './StopwatchImage';
import { useCurrentUserContext } from '../../../../context/UserContext';

const ActionButtons: React.FC<IAction> = (action) => {
    const navigate = useNavigate();
    const dispatch = useReduxDispatch();
    const { selectedActions } = useReduxSelector(state => state.selectedActionsStore);
    const { profile: userProfile } = useCurrentUserContext();
    const [updateAction, { isLoading: unpinning }] = TicketApi.useUpdateActionPinMutation();
    const [showMenu, setShowMenu] = React.useState(false);
    //Decides if the user can edit this action
    const canEdit = (action: IAction) => {
        //temporarily enabled for testing
        //return true;

        if (action.Is_System_Action || action?.ID === 0) return false;
        if (userProfile?.Features.Edit_Any_Action) return true;
        if (userProfile?.Features.Edit_My_Actions && action.Staff_Id == userProfile?.Id) return true;
        return false;
    }

    const canSelect = (action: IAction) => {
        return !userProfile?.Features.External_Interface;
    }

    //Decides if the user can edit this action
    const canDelete = (action: IAction) => {
        //temporarily enabled for testing
        //return true;

        if (action.Is_System_Action || action?.ID === 0) return false;
        if (userProfile?.Features.Delete_Any_Action) return true;
        if (userProfile?.Features.Delete_My_Actions && action.Staff_Id === userProfile?.Id) return true;
        return false;
    }

    const unPinAction = (action: IAction) => {
        updateAction({ TicketId: action?.Call_Id, Id: action.ID, Pinned: false }).unwrap();
    };

    const menuItems = [
        { text: 'Edit', icon: 'edit' },
    ] as MenuItemModel[]

    const menuButton = useRef<ButtonHandle>(null);

    const menuItemClicked = (e: DropDownButtonItemClickEvent) => {
        switch (e.item.text) {
            case 'Edit':
                navigate(`action/${action.ID}`);
                break;
            case 'Delete':
                navigate(`action/${action.ID}/delete`);
                break;
            case 'Attach':
                navigate(`action/${action.ID}/attachments`);
                break;
            case 'Select':
                dispatch(SetSelectedActions([...(selectedActions || []), { actionId: action.ID, ticketId: action.Call_Id }]));
                break;
            case 'Unpin':
                unPinAction(action);

                break;



        }
    }


    return (
        true ? <>
            {!userProfile?.Features.External_Interface && <div className='flex'>
                {action.ID > 0 && <LikeButton {...action} />}
                <StopwatchImage {...action} />
                <AttachmentButton {...action} />
                <DropDownButton fillMode='flat' onItemClick={menuItemClicked} svgIcon={svg.moreVerticalIcon} popupSettings={{ animate: false, popupClass: 'ownership-menu', popupAlign: { horizontal: 'right' } as Align }}>
                    {action.Pinned && <DropDownButtonItem svgIcon={svg.unpinIcon} text="Unpin" />}
                    {canSelect(action) && <DropDownButtonItem svgIcon={svg.checkboxCheckedIcon} text="Select" />}
                    {canEdit(action) && <DropDownButtonItem svgIcon={svg.pencilIcon} text="Edit" />}
                    {canDelete(action) && <DropDownButtonItem svgIcon={svg.trackChangesIcon} text="Delete" />}

                </DropDownButton>
            </div >}</>
            :
            <>
                <ButtonGroup>
                    {action.ID > 0 && <LikeButton {...action} />}
                    <AttachmentButton {...action} />
                    {action.Pinned && <Button title={'Pinned. Click to unpin.'} svgIcon={svg.unpinIcon} fillMode='solid' onClick={(e) => {
                        //Stop action selected event in the parent
                        e.stopPropagation();
                        unPinAction(action)
                    }}></Button>}
                </ButtonGroup>
                {canEdit(action) && <Link to={`action/${action.ID}`} title='Edit' className='nav-link' onClick={(e) => {
                    //Stop action selected event in the parent
                    e.stopPropagation();
                }}><Button svgIcon={svg.pencilIcon} className='off' fillMode='outline'></Button></Link >}
                {canDelete(action) && <Link to={`action/${action.ID}/delete`} title='Delete' className='nav-link'
                    onClick={(e) => {
                        //Stop action selected event in the parent
                        e.stopPropagation();
                    }}><Button svgIcon={svg.trashIcon} className='off' fillMode='outline' title='Delete'></Button></Link>}
            </>
    );
};

export default ActionButtons;